import React, { useState } from 'react';
import {
  Grid,
  TextField
} from '@material-ui/core';
import BorderPickerDialog from './pickers/BorderPickerDialog';


const BorderSelectorGrid = ({
  name,
  label,
  value,
  InputProps = {},
  classes = '',
  setValue
}) => {
  const [showPicker, toggleShowPicker] = useState(false);


  return (
    <Grid container spacing={3} className="pr-2 ml-2 mb-5 items-center">
      <Grid item xs={12} md={3}>
        {label}
      </Grid>
      <Grid item xs={12} md={8} lg={6}>
        <TextField
          variant="outlined"
          color="primary"
          fullWidth
          className={classes}
          name={name}
          label={label}
          defaultValue={value}
          InputProps={InputProps}
          onClick={() => toggleShowPicker(!showPicker)}
        />
        {showPicker &&
          <BorderPickerDialog
            value={value}
            toggleShowPicker={toggleShowPicker}
            onChange={setValue}
          />
        }
      </Grid>
    </Grid>
  );
};

export default BorderSelectorGrid;
